import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import * as platformEvents from 'platformEvents';
import {
  Button,
  SortByDragList,
  ContextMenu,
  ContextMenuContent,
  ContextMenuAction,
  TextLabel,
} from '@wix/wix-base-ui';

import * as util from '#packages/util';
import { waitForAddedCompRef } from '#packages/componentsAddUtils';
import * as utils from '@wix/santa-editor-utils';
import * as compPanelInfra from '#packages/compPanelInfra';
import * as boxSlideShow from '#packages/boxSlideshow';
import * as coreBi from '#packages/coreBi';
import * as stateManagement from '#packages/stateManagement';
import * as BaseUI from '#packages/baseUI';
import * as CompPanelInfra from '#packages/compPanelInfra';
import * as helpIds from '#packages/helpIds';
import { translate } from '#packages/i18n';
import * as initialStateStructureUtil from './initialStateStructureUtil';
import type { EditorAPI } from '#packages/editorAPI';
import type {
  BIEventDefinition,
  BIEventFields,
  CompRef,
  DSRead,
  CompStructure,
} from 'types/documentServices';
import type { Dispatch, StateMapperArgs } from 'types/redux';

const ID_PREFIX = 'ID: ';
const {
  connect,
  STORES: { EDITOR_API },
} = util.hoc;
const { getAllSlides, findCurrentSlide } =
  stateManagement.boxSlideShow.selectors;
const { getStateTitle, hasTitle, isRepeaterStateAllowed } =
  stateManagement.stateBox.selectors;
const slideShowUtils = boxSlideShow.utils.boxSlideShowUtils;
const { multiStateBoxUtils } = utils;

interface StateI {
  pointer: CompRef;
  id: string;
  value: string;
  cleanLabel: string;
}

interface UtilsI {
  getStateTitle: (statePointer: CompRef) => void;
  getNickname: (statePointer: CompRef) => void;
}

function getStateItem(
  utils: UtilsI,
  _stateBoxPointer: CompRef,
  statePointer: CompRef,
  selectedState: StateI,
  dsRead: DSRead,
) {
  const stateHasTitle = hasTitle(dsRead, statePointer);
  const stateLabel = utils.getStateTitle(statePointer);

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line you-dont-need-lodash-underscore/assign
  const stateData = _.assign(
    {
      id: statePointer.id,
      label: stateHasTitle ? stateLabel : `${ID_PREFIX}${stateLabel}`,
      cleanLabel: stateLabel,
      pointer: statePointer,
    },
    stateHasTitle && { value: utils.getNickname(statePointer) },
  );

  if (stateData.id === selectedState.id) {
    // TODO: fix
    // @ts-expect-error
    stateData.selected = true;
  }

  return stateData;
}

function getStates(
  utils: UtilsI,
  allStatesPointers: CompRef[],
  stateBox: CompRef,
  selectedState: StateI,
  dsRead: DSRead,
) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line you-dont-need-lodash-underscore/map
  return _.map(allStatesPointers, function (statePointer) {
    return getStateItem(utils, stateBox, statePointer, selectedState, dsRead);
  });
}

// eslint-disable-next-line react/prefer-es6-class
const BoxStateBoxManageStatePanel = createReactClass({
  displayName: 'StateBoxManageStatesPanel',
  mixins: [compPanelInfra.compPanelMixin],
  propTypes: {
    stateBox: PropTypes.object,
    allStatesPointers: PropTypes.array,
    biParams: PropTypes.object,
    sendBi: PropTypes.func,
    preventMouseDown: PropTypes.func,
    allowMouseDown: PropTypes.func,
    hideQuickTip: PropTypes.func,
    utils: PropTypes.object,
  },
  getInitialState() {
    const currentState = findCurrentSlide(
      this.getEditorAPI().dsRead,
      this.props.stateBox,
    );
    this.isCurrentlyInOperation = false;

    return {
      selectedState: currentState,
      editIndex: -1,
    };
  },
  UNSAFE_componentWillMount() {
    this.states = this.getStates();
    this.operations = [];
  },
  // eslint-disable-next-line react/no-deprecated
  componentWillUpdate(
    _nextProps,
    nextState: { selectedState: StateI; editIndex: number },
  ) {
    this.states = getStates(
      this.props.utils,
      this.props.allStatesPointers,
      this.props.stateBox,
      nextState.selectedState,
      this.getEditorAPI().dsRead,
    );
  },
  UNSAFE_componentWillReceiveProps(nextProps: { stateBox: CompRef }) {
    this.states = getStates(
      this.props.utils,
      this.props.allStatesPointers,
      nextProps.stateBox,
      this.state.selectedState,
      this.getEditorAPI().dsRead,
    );
    const nextSelectedState = findCurrentSlide(
      this.getEditorAPI().dsRead,
      nextProps.stateBox,
    );

    if (!_.isEqual(nextSelectedState, this.state.selectedState)) {
      //current state was changed from outside
      this.setState({ selectedState: nextSelectedState });
    }
  },
  getStates() {
    return getStates(
      this.props.utils,
      this.props.allStatesPointers,
      this.props.stateBox,
      this.state.selectedState,
      this.getEditorAPI().dsRead,
    );
  },
  getSelectedStateItem() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line you-dont-need-lodash-underscore/find
    return _.find(this.states, { id: this.state.selectedState.id });
  },
  startOperation() {
    this.getEditorAPI().preventMouseDown();
    let endOperation;
    const operation = new Promise((resolve) => {
      endOperation = resolve;
    });
    this.operations.push(operation);
    return endOperation;
  },
  endOperation(endOperation: () => void) {
    this.getEditorAPI().allowMouseDown();
    endOperation();
  },
  async waitForOperations() {
    await Promise.all(this.operations);
    this.operations = [];
  },
  isInOperation() {
    return this.isCurrentlyInOperation;
  },
  async selectState(stateValue: StateI, stateIndex: number) {
    await this.waitForOperations();

    const editorAPI = this.getEditorAPI();
    const endOperation = this.startOperation();

    await new Promise((resolve) => {
      this.setState({ selectedState: stateValue.pointer }, resolve);
    });

    await new Promise((resolve) => {
      editorAPI.components.behaviors.execute(
        this.props.stateBox,
        'changeState',
        { stateIndex },
        resolve,
      );
    });

    this.endOperation(endOperation);

    this.props.hideQuickTip();
  },
  async moveState(startIdx: number, dropIdx: number) {
    if (startIdx === dropIdx) {
      return;
    }

    await this.waitForOperations();

    const editorAPI = this.getEditorAPI();
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line you-dont-need-lodash-underscore/find-index
    const selectedIndex = _.findIndex(this.getStates(), { selected: true });
    const stateToMove = this.states[startIdx].pointer;
    editorAPI.components.arrangement.moveToIndex(stateToMove, dropIdx, {
      dontAddToUndoRedoStack: false,
    });
    this.props.sendBi(
      coreBi.events.boxSlideShow.MANAGE_SLIDES_SLIDE_REORDERED,
      this.props.biParams,
    );

    editorAPI.dsActions.waitForChangesApplied(() => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line you-dont-need-lodash-underscore/find-index
      const newSelectedIndex = _.findIndex(this.getStates(), {
        selected: true,
      });
      if (selectedIndex === newSelectedIndex) {
        return;
      }

      const endOperation = this.startOperation();
      editorAPI.components.behaviors.execute(
        this.props.stateBox,
        'changeState',
        { stateIndex: dropIdx },
        () => this.endOperation(endOperation),
      );
    });
  },
  notifyApplicationIfNeeded(
    editorAPI: EditorAPI,
    newStateRef: CompRef,
    isDuplicatedState: boolean,
  ) {
    const stateBoxRef = this.props.stateBox;
    const primaryConnection =
      editorAPI.dsRead.platform.controllers.connections.getPrimaryConnection(
        stateBoxRef,
      );
    if (!primaryConnection) {
      return;
    }

    const { controllerRef } = primaryConnection;
    const { applicationId: appDefinitionId } =
      editorAPI.components.data.get(controllerRef) || {};
    const { applicationId } =
      editorAPI.platform.getAppDataByAppDefId(appDefinitionId);

    if (isDuplicatedState) {
      editorAPI.platform.notifyApplication(
        applicationId,
        platformEvents.factory.stateDuplicated({
          componentRef: stateBoxRef,
          newDuplicatedStateRef: newStateRef,
        }),
      );
    } else {
      editorAPI.platform.notifyApplication(
        applicationId,
        platformEvents.factory.stateAdded({
          componentRef: stateBoxRef,
          addedStateRef: newStateRef,
        }),
      );
    }
  },
  async addState(
    stateDef: CompStructure,
    index: number,
    isDuplicatedState = false,
    stateNickname = '',
  ) {
    const editorAPI: EditorAPI = this.getEditorAPI();

    const addedState = await waitForAddedCompRef(
      editorAPI.components.add(this.props.stateBox, stateDef),
    );

    editorAPI.components.arrangement.moveToIndex(addedState, index, {
      dontAddToUndoRedoStack: true,
    });
    this.getEditorAPI().history.add('added a state to state show', {
      isAddingComponent: true,
    });

    await editorAPI.dsActions.waitForChangesAppliedAsync();

    this.notifyApplicationIfNeeded(editorAPI, addedState, isDuplicatedState);

    if (stateNickname) {
      editorAPI.components.code.setNickname(addedState, stateNickname);
    }

    const addedStateData = getStateItem(
      this.props.utils,
      this.props.stateBox,
      addedState,
      this.state.selectedState,
      this.getEditorAPI().dsRead,
    );

    this.selectState(addedStateData, index);
  },
  async duplicateState(state: StateI, stateIndex: number) {
    const stateNickname = this.calculateDuplicatedStepNickname(state.pointer);
    const stateDef = this.getEditorAPI().components.serialize(state.pointer);
    await this.addState(stateDef, stateIndex + 1, true, stateNickname);
  },
  async duplicateCurrentState() {
    const currState = this.getSelectedStateItem();
    const totalStates = this.states.length;
    await this.duplicateState(currState, totalStates - 1);
    this.props.sendBi(
      coreBi.events.boxSlideShow.MANAGE_SLIDES_DUPLICATE_CURRENT_SLIDE,
      this.props.biParams,
    );
  },
  calculateDuplicatedStepNickname(duplicatedStatePointer: CompRef) {
    return multiStateBoxUtils.getDuplicatedStateNickname(
      this.getEditorAPI(),
      duplicatedStatePointer,
      this.states,
    );
  },
  async deleteState(state: StateI, _stateIndex: number, allStates: StateI[]) {
    if (allStates.length <= 1) {
      return;
    }

    const editorAPI = this.getEditorAPI();
    const [firstState] = allStates;

    await this.selectState(firstState, 0);

    await editorAPI.components.remove(state.pointer);

    editorAPI.history.add('removed a state from state show');

    const selectedState = findCurrentSlide(
      editorAPI.dsRead,
      this.props.stateBox,
    );

    this.setState({ selectedState });
  },
  changeStateName(state: StateI) {
    const newTitle = state.value || state.cleanLabel;
    const editorAPI = this.getEditorAPI();
    editorAPI.components.code.setNickname(state.pointer, newTitle);
    editorAPI.dsActions.waitForChangesApplied(() => {
      editorAPI.selection.selectComponentByCompRef(this.props.stateBox);
    });
  },
  isRepeaterState(compRef: CompRef) {
    const editorAPI = this.getEditorAPI();
    return editorAPI.components.is.repeater(compRef);
  },
  getNewContainerStateStructure() {
    const editorAPI = this.getEditorAPI();
    const currState = this.getSelectedStateItem();
    if (this.isRepeaterState(currState.pointer)) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line you-dont-need-lodash-underscore/find
      const containerState = _.find(
        this.states,
        (state) => !this.isRepeaterState(state.pointer),
      );
      if (containerState) {
        // eslint-disable-next-line @wix/santa-editor/dsReadSerializeIsTooExpensive
        return editorAPI.components.serialize(containerState.pointer);
      }
      return initialStateStructureUtil.CONTAINER_STATE;
    }
    // eslint-disable-next-line @wix/santa-editor/dsReadSerializeIsTooExpensive
    return editorAPI.components.serialize(currState.pointer);
  },
  async addNewContainerState() {
    const stateDef = this.getNewContainerStateStructure();
    stateDef.components = [];
    const totalStates = this.states.length;
    await this.addState(stateDef, totalStates);
    this.props.sendBi(
      coreBi.events.boxSlideShow.MANAGE_SLIDES_ADD_NEW_SLIDE,
      this.props.biParams,
    );
  },
  async addNewRepeaterState() {
    const repeaterStructure = initialStateStructureUtil.REPEATER_STATE;
    const totalStates = this.states.length;
    await this.addState(repeaterStructure, totalStates);
    this.props.sendBi(
      coreBi.events.boxSlideShow.MANAGE_SLIDES_ADD_NEW_SLIDE,
      this.props.biParams,
    );
  },
  getEditIdValidators() {
    return [
      {
        validator: util.validate.notEmptyString,
        invalidMessage: 'multiStateBox_ManageStates_State_Invalid_Name',
      },
      {
        validator: this.isEditingValueUnique,
        invalidMessage: 'multiStateBox_ManageStates_State_Invalid_Name_Unique',
      },
      {
        validator: util.validate.eventName,
        invalidMessage:
          'multiStateBox_ManageStates_State_Invalid_Name_Characters',
      },
    ];
  },
  valueEditStart(index: number) {
    this.setState({ editIndex: index });
  },
  valueEditEnd() {
    this.setState({ editIndex: -1 });
  },
  isEditingValueUnique(value: number) {
    return (
      this.state.editIndex === -1 ||
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line you-dont-need-lodash-underscore/includes
      !_.includes(this.getEditExistingValues(), value)
    );
  },
  getEditExistingValues() {
    const existingValues = this.states.map(
      (state: StateI) => state.value || state.cleanLabel,
    );
    existingValues.splice(this.state.editIndex, 1);
    return existingValues;
  },
  getMenuActionsOverrides() {
    return {
      toggleDefault: {
        enable: false,
      },
      toggleEditValue: {
        priority: 3,
        label: translate('multiStateBox_ManageStates_State_Rename'),
        enable: true,
      },
      toggleEditLabel: {
        enable: false,
      },
      duplicate: {
        priority: 2,
        label: translate('multiStateBox_ManageStates_State_Duplicate'),
      },
      delete: {
        priority: 1,
        label: translate('multiStateBox_ManageStates_State_Delete'),
        enable: this.states.length > 1,
      },
    };
  },
  getAddNewStateButton() {
    return React.createElement(
      Button,
      {
        // TODO: fix
        // @ts-expect-error
        label: 'multiStateBox_ManageStates_State_AddState_Link',
        className: 'add-new-state',
        automationId: 'add-state-btn',
      },
      [translate('multiStateBox_ManageStates_State_AddState_Link')],
    );
  },
  getNewStatesItems() {
    return [
      {
        id: 'add-container-state',
        icon: 'container',
        label: 'multiStateBox_ManageStates_Add_State_Container',
        onClick: this.addNewContainerState,
      },
      {
        id: 'add-repeater-state',
        icon: 'repeater',
        label: 'multiStateBox_ManageStates_Add_State_Repeater',
        onClick: this.addNewRepeaterState,
      },
    ];
  },
  render() {
    return (
      <CompPanelInfra.compPanelFrame
        contentClass="box-slide-show-manage-slides-panel"
        title="multiStateBox_ManageStates_Header_Label"
        helpId={helpIds.EXTERNAL.STATE_BOX_MANAGE_STATES}
        {...this.getFrameProps()}
      >
        <SortByDragList
          selectable={true}
          value={this.getStates()}
          selectItem={this.selectState}
          menuActionsOverrides={this.getMenuActionsOverrides()}
          // TODO: Fix
          // @ts-expect-error
          enableSetAsDefault={false}
          labelValidator={this.getEditIdValidators()}
          valueValidator={this.getEditIdValidators()}
          itemMoved={this.moveState}
          duplicateItem={this.duplicateState}
          deleteItem={this.deleteState}
          itemChanged={this.changeStateName}
          itemValuePrefix="ID"
          onValueEditStart={this.valueEditStart}
          onLabelEditStart={this.valueEditStart}
          onValueEditEnd={this.valueEditEnd}
          onLabelEditEnd={this.valueEditEnd}
          labelPlaceholder="multiStateBox_ManageStates_State_Invalid_Name_Placeholder"
          valuePlaceholder="multiStateBox_ManageStates_State_Invalid_Name_Placeholder"
          submitEditLabelButtonText={translate(
            'multiStateBox_ManageStates_State_Rename_Done',
          )}
          submitEditValueButtonText={translate(
            'multiStateBox_ManageStates_State_Rename_Done',
          )}
        />
        {this.props.isRepeaterStateAllowed ? (
          <div className="button-wrapper">
            <ContextMenu
              direction="MIDDLE"
              customButton={this.getAddNewStateButton()}
              automationId="add-state-menu"
            >
              <ContextMenuContent>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line you-dont-need-lodash-underscore/map */}
                {_.map(this.getNewStatesItems(), (item) => (
                  <ContextMenuAction
                    automationId={item.id}
                    key={item.id}
                    className="add-state-action"
                    onClick={item.onClick}
                  >
                    <BaseUI.symbol name={item.icon} />
                    <TextLabel value={item.label} />
                  </ContextMenuAction>
                ))}
              </ContextMenuContent>
            </ContextMenu>
            <Button
              automationId="duplicate-state-btn"
              onClick={this.duplicateCurrentState}
              className="duplicate-state btn-text"
            >
              {translate('multiStateBox_ManageStates_State_Duplicate_Button')}
            </Button>
          </div>
        ) : (
          <div className="button-wrapper">
            <BaseUI.button
              label="multiStateBox_ManageStates_State_Duplicate_Button"
              onClick={this.duplicateCurrentState}
              className="mainButton"
            />
            <BaseUI.button
              label="multiStateBox_ManageStates_State_AddState_Link"
              onClick={this.addNewContainerState}
              className="secondaryButton btn-text"
            />
          </div>
        )}
      </CompPanelInfra.compPanelFrame>
    );
  },
});

const mapStateToProps = ({ editorAPI, state, dsRead }: StateMapperArgs) => {
  const [stateBox] = editorAPI.selection.getSelectedComponents();
  const allStatesPointers = getAllSlides(dsRead, stateBox);
  return {
    stateBox,
    allStatesPointers,
    biParams: editorAPI.components.getDefaultBiParams([stateBox]),
    preventMouseDown: () => editorAPI.preventMouseDown(),
    allowMouseDown: () => editorAPI.allowMouseDown(),
    hideQuickTip: () => slideShowUtils.hideQuickTip(editorAPI),
    isRepeaterStateAllowed: isRepeaterStateAllowed(state),
    getType: (compRef: CompRef) => editorAPI.components.getType(compRef),
    utils: {
      getStateTitle: (statePointer: CompRef) =>
        getStateTitle(dsRead, stateBox, statePointer),
      getNickname: (statePointer: CompRef) =>
        stateManagement.components.selectors.getNickname(statePointer, dsRead),
    },
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  sendBi: (event: BIEventDefinition, parameters: BIEventFields) =>
    dispatch(stateManagement.bi.actions.event(event, parameters)),
});

export default connect(
  EDITOR_API,
  mapStateToProps,
  mapDispatchToProps,
)(BoxStateBoxManageStatePanel);
